import { createFileRoute } from "@tanstack/react-router";
import { WORKBENCH_SEARCH } from "@/features/analytics/workbench/use-workbench-route";
import { findAnalysis } from "@/features/analytics/analyses";
import { ANALYSIS_PAGES } from "@/features/analytics/registry";

export const Route = createFileRoute("/analytics/$slug")({
  validateSearch: WORKBENCH_SEARCH,
  component: AnalysisRoute,
});

function AnalysisRoute() {
  const { slug } = Route.useParams();
  const analysis = findAnalysis(slug);
  if (!analysis) {
    return (
      <div className="flex flex-col gap-2 p-6">
        <h1 className="text-base font-medium">Analysis not found</h1>
        <p className="text-sm text-muted-foreground">
          There is no in-house analysis called <code>{slug}</code>.
        </p>
      </div>
    );
  }
  const Page = ANALYSIS_PAGES[analysis.slug];
  return <Page />;
}
